import React from 'react';
import {
  makeStyles,
  InputLabel,
  Input,
  FormControl,
  Chip,
  Select,
  MenuItem
} from '@material-ui/core';
import { t } from 'src/shared/literals';

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '200px',
    margin: theme.spacing(1)
  },
  formControlFullWidth: {
    width: '99%',
    margin: theme.spacing(1)
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  chip: {
    margin: 2
  }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

const FormSelectChip = ({ field, handleChangeField }) => {
  const classes = useStyles();

  const getChipLabelByValue = (value, fieldOptions) =>
    fieldOptions.filter((x) => x.id === value)[0].name;

  const { name, value, options, readonly, errorMessage, fullWidth } = field;

  const handleChangeMultiple = (event) => {
    const { name } = field;
    const { value } = event.target;

    event.target = {
      name,
      value
    };

    handleChangeField(event);
  };

  return (
    <FormControl
      className={fullWidth ? classes.formControlFullWidth : classes.formControl}
      key={name}
    >
      <InputLabel id={`select-chip-label-${name}`}>
        {t(name.toString())}
      </InputLabel>
      <Select
        error={Boolean(errorMessage)}
        helperText={t(errorMessage)}
        multiple
        labelId={`select-chip-label-${name}`}
        value={!value || !value.length ? [] : value}
        onChange={handleChangeMultiple}
        inputProps={{
          readOnly: readonly
        }}
        input={<Input />}
        renderValue={(selected) => (
          <div className={classes.chips}>
            {selected.map((value) => (
              <Chip
                key={value}
                label={getChipLabelByValue(value, options)}
                className={classes.chip}
              />
            ))}
          </div>
        )}
        MenuProps={MenuProps}
      >
        {options.map((option) => (
          <MenuItem key={option.id} value={option.id.toLowerCase()}>
            {option.name.toUpperCase()}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FormSelectChip;
